/* eslint-disable max-len */
import { useAllieToast } from "@allie/app-ui-lib";

export enum MessageTypes {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  DARK = 'dark',
}

const MessageColors = {
  [MessageTypes.ERROR]: 'danger',
  [MessageTypes.INFO]: 'primary',
  [MessageTypes.SUCCESS]: 'success',
  [MessageTypes.WARNING]: 'warning',
  [MessageTypes.DARK]: 'dark',
}

const MessageIcons = {
  [MessageTypes.ERROR]: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z' stroke-miterlimit='10' class='ionicon-fill-none ionicon-stroke-width'/><path d='M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z'/></svg>",
  [MessageTypes.INFO]: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z' stroke-miterlimit='10' class='ionicon-fill-none ionicon-stroke-width'/><path stroke-linecap='round' stroke-linejoin='round' d='M220 220h32v116' class='ionicon-fill-none ionicon-stroke-width'/><path stroke-linecap='round' stroke-miterlimit='10' d='M208 340h88' class='ionicon-fill-none ionicon-stroke-width'/><path d='M248 130a26 26 0 1026 26 26 26 0 00-26-26z'/></svg>",
  [MessageTypes.SUCCESS]: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z' stroke-miterlimit='10' class='ionicon-fill-none ionicon-stroke-width'/><path stroke-linecap='round' stroke-linejoin='round' d='M352 176L217.6 336 160 272' class='ionicon-fill-none ionicon-stroke-width'/></svg>",
  [MessageTypes.WARNING]: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z' stroke-linecap='round' stroke-linejoin='round' class='ionicon-fill-none ionicon-stroke-width'/><path d='M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z'/></svg>",
}

const MESSAGE_DURATION = 3000;
const MESSAGE_POSITION = 'top';

export interface MessageProps {
  message?: string;
  title?: string;
  type?: MessageTypes;
  duration?: number;
  position?: 'top' | 'bottom';
  closable?: boolean;
}

export const useMessages = () => {
  const [presentToast] = useAllieToast();

  const showMessage = ({
    message,
    title,
    type = MessageTypes.INFO,
    duration = MESSAGE_DURATION,
    position = MESSAGE_POSITION,
    closable = false,
  }: MessageProps) => {
    if (title || message) {
      presentToast({
        header: title,
        icon: MessageIcons[type],
        message,
        color: MessageColors[type],
        duration,
        position,
        ...(
          closable
          ? { buttons: [{ text: 'X', role: 'cancel' }] }
          : {}
        ),
      });
    }
  };

  return { showMessage };
};
